<template>
  <button
    :disabled="disabled"
    class="group relative w-full overflow-hidden px-4 py-2.5 transition-all"
    :class="[
      disabled && 'cursor-default!',
      selected && 'rounded-large! bg-secondary-container!',
      !selected && 'bg-surface-container-low rounded-extra-small',
      compact && 'min-h-10',
      !compact && 'min-h-16',
    ]"
  >
    <div class="flex flex-row items-center gap-3">
      <slot name="leading"></slot>
      <BaseIcon
        v-if="icon"
        size="24"
        class="shrink-0"
        :filled="selected"
        :class="[
          selected && 'text-on-secondary-container',
          !selected && 'text-on-surface-variant',
          disabled && 'text-on-surface/38!',
        ]"
        >{{ icon }}</BaseIcon
      >
      <div class="flex grow flex-col items-start text-left">
        <p class="text-body-large text-on-surface" :class="[disabled && 'text-on-surface/38!']">
          {{ title }}
        </p>
        <p
          v-if="description"
          class="text-body-medium text-on-surface-variant"
          :class="[disabled && 'text-on-surface/38!']"
        >
          {{ description }}
        </p>
        <slot name="tertiary"></slot>
      </div>
      <span
        v-if="trailingText"
        class="text-label-small text-on-surface-variant text-right whitespace-nowrap"
        :class="[disabled && 'text-on-surface/38!']"
      >
        {{ trailingText }}
      </span>
      <BaseCheckbox
        v-if="!isRadio"
        :is-checked="selected"
        :disabled="disabled"
        :show-state-layer="false"
        class="-mr-2"
      />
      <BaseRadioButton
        v-else
        :is-checked="selected"
        :disabled="disabled"
        :show-state-layer="false"
        class="-mr-2"
      />
    </div>
    <BaseStateLayer type="surface-neutral" v-if="!disabled" />
  </button>
</template>

<script setup lang="ts">
  import BaseCheckbox from '../checkbox/BaseCheckbox.vue'
  import BaseIcon from '../icon/BaseIcon.vue'
  import BaseStateLayer from '../state-layer/BaseStateLayer.vue'
  import BaseRadioButton from '../radio-button/BaseRadioButton.vue'

  defineProps<Props>()

  interface Props {
    title: string
    description?: string
    trailingText?: string
    icon?: string
    selected: boolean
    disabled?: boolean
    isRadio?: boolean
    compact?: boolean
  }
</script>
